import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { motion } from 'framer-motion';

export default function ContactSection() {
  return (
    <section id="contact" className="sm:p-20 sm:px-4 md:px-8">
      {/* <section className="py-12 px-6  max-w-4xl mx-auto text-black dark:text-white  ">
        <h2 className="text-2xl font-semibold mb-4  dark:text-white text-black">
          🌱 Outside of Code
        </h2>
        <p className=" leading-relaxed  dark:text-white text-black">
          When I’m not coding, you’ll probably find me running, lifting, or
          crocheting random things with no pattern. I care a lot about
          consistency, growth, and balance — and I try to bring that mindset
          into how I write code and live life.
        </p>

        <h3 className="text-xl mt-6 mb-2 font-medium">🎧 Fun Fact</h3>
        <p className=" dark:text-white text-black">
          I get a lot of bug-fixing ideas mid-run. I’ve paused workouts just to
          write down code thoughts before they disappear.
        </p>
      </section> */}
      <section className="py-16 px-2">
        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          {/* What I’m Doing Now */}
          {/* <div className="bg-white dark:bg-neutral-900 shadow-md rounded-xl p-6"> */}
          <div className="cursor-pointer p-6 rounded-2xl border border-primary/30 dark:border-primary/50 shadow-md hover:shadow-lg bg-white/80 dark:bg-neutral-900/80 backdrop-blur-sm transition-all">
            <h3 className="text-xl font-semibold mb-4 dark:text-white text-black">
              🌱 Outside of Code
            </h3>
            <p className=" leading-relaxed  dark:text-white text-black">
              When I’m not coding, you’ll probably find me running, lifting, or
              crocheting random things with no pattern. I care a lot about
              consistency, growth, and balance — and I try to bring that mindset
              into how I write code and live life.
            </p>
          </div>

          {/* Recent Highlights */}
          {/* <div className="bg-white dark:bg-neutral-900 shadow-md rounded-xl p-6"> */}
          <div className="cursor-pointer p-6 rounded-2xl border border-primary/30 dark:border-primary/50 shadow-md hover:shadow-lg bg-white/80 dark:bg-neutral-900/80 backdrop-blur-sm transition-all">
            <h3 className="text-xl font-semibold mb-4 dark:text-white text-black">
              🎧 Fun Fact
            </h3>
            <p className=" leading-relaxed  dark:text-white text-black">
              When I’m not coding, you’ll probably find me running, lifting, or
              crocheting random things with no pattern. I care a lot about
              consistency, growth, and balance — and I try to bring that mindset
              into how I write code and live life.
            </p>
          </div>
        </div>
      </section>
      <footer className=" py-10 px-6 text-center bg-primary  dark:bg-neutral-900/80">
        {/* <img
          src="/profile_image.jpg"
          alt="Pranjal Varade"
          className="w-36 h-36 rounded-full shadow-lg object-cover"
        /> */}
        <h2 className="text-xl font-semibold dark:text-white text-white">
          👋 Let’s Connect
        </h2>
        <p className="dark:text-white text-white mt-2">
          Open to frontend / full stack roles
        </p>
        {/* <div className="flex justify-center gap-4 mt-4">
          <a
            href="mailto:pranjalsocial1097@gmail.com"
            className="text-blue-500 underline"
          >
            Email Me
          </a>
          <a
            href="https://pranjal-website.vercel.app/"
            className="text-blue-500 underline"
          >
            Website
          </a>
          <a
            href="https://www.linkedin.com/in/pranjal-varade/"
            className="text-blue-500 underline"
          >
            LinkedIn
          </a>
        </div> */}
        {/* <div className="mt-4 flex justify-center md:justify-start gap-4"> */}
        <div className="mt-4 flex justify-center  gap-4 text-white dark:text-white flex-wrap ">
          <a
            href="mailto:pranjalsocial1097@gmail.com"
            target="_blank"
            //className="text-blue-500 underline"
            className="px-4 py-2 rounded-full border text-sm font-medium transition hover:bg-primary hover:text-white"
          >
            Email Me
          </a>
          <a
            //  href="https://github.com/PranjalVarade"
            href="https://github.com/Pranjal-Varade97"
            target="_blank"
            //className="text-blue-500 underline"
            className="px-4 py-2 rounded-full border text-sm font-medium transition hover:bg-primary hover:text-white"
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/pranjal-varade/"
            target="_blank"
            // className="text-blue-500 underline"
            className="px-4 py-2 rounded-full border text-sm font-medium transition hover:bg-primary hover:text-white"
          >
            LinkedIn
          </a>
          <a
            href="/Pranjal_Varade_Resume.pdf"
            target="_blank"
            //className="text-blue-500 underline"
            className="px-4 py-2 rounded-full border text-sm font-medium transition hover:bg-primary hover:text-white"
          >
            Resume
          </a>
          <a
            href="https://pranjal-website.vercel.app/"
            target="_blank"
            //className="text-blue-500 underline"
            className="px-4 py-2 rounded-full border text-sm font-medium transition hover:bg-primary hover:text-white"
          >
            Website
          </a>
        </div>
      </footer>

      {/* <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="max-w-4xl mx-auto text-center bg-white/80 dark:bg-neutral-800/70 backdrop-blur-sm rounded-xl shadow-lg p-10"
      > */}
      {/* <h2 className="text-4xl font-bold mb-4 text-black dark:text-white">
          Let’s Connect
        </h2>
        <p className="text-lg text-gray-700 dark:text-gray-300 mb-8">
          Have a project in mind, a question, or just want to say hi? I'd love
          to hear from you.
        </p> */}

      {/* <div className="flex justify-center items-center gap-6 text-2xl text-primary">
          <motion.a
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.95 }}
            href="https://github.com/PranjalVarade"
            target="_blank"
            rel="noopener noreferrer"
            className="transition text-gray-800 dark:text-white hover:text-accent"
          >
            <FaGithub />
          </motion.a>
          <motion.a
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.95 }}
            href="https://www.linkedin.com/in/pranjal-varade/"
            target="_blank"
            rel="noopener noreferrer"
            className="transition text-gray-800 dark:text-white hover:text-accent"
          >
            <FaLinkedin />
          </motion.a>
          <motion.a
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 0.95 }}
            href="mailto:pranjalsocial1097@gmail.com"
            className="transition text-gray-800 dark:text-white hover:text-accent"
          >
            <FaEnvelope />
          </motion.a>
        </div> */}

      {/* Optional Email Button */}
      {/* <div className="mt-8">
          <a
            href="mailto:pranjalsocial1097@gmail.com"
            className="inline-block px-6 py-3 bg-primary text-white font-medium rounded-lg shadow-md hover:bg-primary-dark transition"
          >
            Send a Message
          </a>
        </div> */}
      {/* </motion.div> */}
    </section>
  );
}
